import internationalPaymentConfigTypes from './types';

const intialState = {
  saving: false,
  loading: false,
  stripeAccount: null,
  error: null,
};

function IntPaymentConfigReducer(state = intialState, { type, payload }) {
  switch (type) {
    case internationalPaymentConfigTypes.ADD_BANK_ACCOUNT_REQUEST:
      return {
        ...state,
        saving: true,
      };
    case internationalPaymentConfigTypes.ADD_BANK_ACCOUNT_SUCCESS:
      return {
        ...state,
        saving: false,
      };
    case internationalPaymentConfigTypes.ADD_BANK_ACCOUNT_FAILURE:
      return {
        ...state,
        saving: false,
        error: payload,
      };

    case internationalPaymentConfigTypes.GET_BANK_ACCOUNT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case internationalPaymentConfigTypes.GET_BANK_ACCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        stripeAccount: payload
      };
    case internationalPaymentConfigTypes.GET_BANK_ACCOUNT_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}

export default IntPaymentConfigReducer;
